import axios from 'axios'
import { swalError } from '../../../common/components/Swaler'
import settings from '../../../settings'
import setAuthorizationToken from '../utils/setAuthorizationToken'

axios.defaults.baseURL = settings.hostname



export const logout = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('userType')
  setAuthorizationToken(false)
  window.location.href = window.BASE_NAME // NOTE: Use react router instead
}

export function login(data) {

  return (dispatch) => {
    axios
      .post(`${window.MYQLOCX_API}/tokens`, data)
      .then((res) => {
        const { token } = res.data
        const { userType } = res.data
        localStorage.setItem('token', token)
        localStorage.setItem('userType', userType)
        dispatch({ type: 'LOGIN_SUCCESS', payload: token })
        setAuthorizationToken(token)

        window.location.href = window.BASE_NAME // NOTE: Use react router instead
      })
      .catch((err) => {
        console.log(err)
        swalError('Wrong username or password')
      })
  }
}

export function isLoggedIn() {
  const { token } = localStorage
  return token && token.length
}

export function shouldShowSidebar() {
  const { userType } = localStorage
  return userType && userType !== 'carrier' && userType !== 'subadmin' && userType !== 'c_terminal' && userType !== 'vendor' && !window.location.href.includes('polls')
}
